import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AccountingMethodRow,
  AccountingPeriod,
  AccountingSettings,
  SaveAccountingMethod,
  SaveFiscalCalendar,
  SaveFiscalYear,
} from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

import { toQueryParams } from './journal-api.service';

@Injectable({ providedIn: 'root' })
export class AccountingApiService {
  constructor(private http: HttpClient) {}

  private base(companyId: string): string {
    return `/api/v1.0/companies/${companyId}`;
  }

  getFiscalCalendar(companyId: string, fiscalYear?: number): Observable<AccountingPeriod[]> {
    return this.http.get<AccountingPeriod[]>(`${this.base(companyId)}/fiscal-calendar`, {
      params: toQueryParams({ fiscal_year: fiscalYear }),
    });
  }

  /** Pauly Admin only. Replaces the year's dates; period ids stay the same. */
  saveFiscalYear(companyId: string, fiscalYear: number, body: SaveFiscalYear): Observable<AccountingPeriod[]> {
    return this.http.put<AccountingPeriod[]>(`${this.base(companyId)}/fiscal-calendar/${fiscalYear}`, body);
  }

  /** Pauly Admin only. Validates the years together; this is how a year boundary moves. */
  saveFiscalCalendar(companyId: string, body: SaveFiscalCalendar): Observable<AccountingPeriod[]> {
    return this.http.put<AccountingPeriod[]>(`${this.base(companyId)}/fiscal-calendar`, body);
  }

  removeFiscalYear(companyId: string, fiscalYear: number): Observable<unknown> {
    return this.http.delete(`${this.base(companyId)}/fiscal-calendar/${fiscalYear}`);
  }

  getSettings(companyId: string): Observable<AccountingSettings> {
    return this.http.get<AccountingSettings>(`${this.base(companyId)}/accounting-settings`);
  }

  /** PUT replaces every setting: always send the whole form. */
  saveSettings(companyId: string, body: AccountingSettings): Observable<AccountingSettings> {
    return this.http.put<AccountingSettings>(`${this.base(companyId)}/accounting-settings`, body);
  }

  getMethods(companyId: string): Observable<AccountingMethodRow[]> {
    return this.http.get<AccountingMethodRow[]>(`${this.base(companyId)}/accounting-methods`);
  }

  saveMethod(companyId: string, body: SaveAccountingMethod): Observable<AccountingMethodRow[]> {
    return this.http.post<AccountingMethodRow[]>(`${this.base(companyId)}/accounting-methods`, body);
  }
}
